import { BigNumber } from 'bignumber.js';
import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for BigNumber
 * Serialized format is a plain string
 */
export const bigNumberSerializer = CreateSerializer(serializeBigNumber, deserializeBigNumber);
function serializeBigNumber(value) {
    const asBigNumber = Object.assign(new BigNumber(0), value);
    return asBigNumber.toString();
}
function deserializeBigNumber(value) {
    return new BigNumber(value);
}
